'use client';

import { orderFilters } from '@components/FilterPage/FilterFacets/FilterFacetsContent/orderFilters';
import { Accordion, Flex, freddyTheme } from '@coolblue-development/freddy';
import { FilterCategories, filterCategories, Filters } from '@server/careers-backend/search';
import React from 'react';

import { FilterFacetItem } from './FilterFacetItem';

type Props = {
  filters: Filters | undefined;
  version: 'full' | 'accordion';
};

export const FilterFacetsContent = ({ filters, version }: Props) => {
  const isAccordionVersion = version === 'accordion';

  const FilterContentWrapper = isAccordionVersion ? Accordion : Flex;

  return (
    <FilterContentWrapper
      component='form'
      onSubmit={e => e.preventDefault()}
      variant='bordered'
      sx={{ flexDirection: 'column', gap: freddyTheme.spacing[400] }}
    >
      {orderFilters(filters).map(({ key, options }) => (
        <FilterFacetItem
          key={key}
          isBoolean={[filterCategories.isCoolblueEnergy as string].includes(key)}
          filterCategory={key as FilterCategories}
          filterOptions={options}
          isAccordionVersion={isAccordionVersion}
        />
      ))}
    </FilterContentWrapper>
  );
};
